import { AnyAction } from 'redux';
import {
  FETCH_TINS_DETAILS_REQUEST,
  FETCH_TINS_DETAILS_SUCCESS,
  FETCH_TINS_DETAILS_FAILURE,
  SAVE_CUSTOM_LIST_SUCCESS,
  SAVE_CUSTOM_LIST_REQUEST,
  SAVE_CUSTOM_LIST_FAILURE,
  RESET_TINS_DETAILS,
  SET_FILTER_LIST_SEARCH,
  REENTER_TINS,
  UPDATE_LIST_NAME,
  SET_ADD_MORE_TINS_SEARCH,
  ADD_SINGLE_TIN_TO_LIST_REQUEST,
  ADD_SINGLE_TIN_TO_LIST_SUCCESS,
  ADD_SINGLE_TIN_TO_LIST_FAILURE,
  UPDATE_TIN_SELECTION,
  ADD_MORE_TINS_DATA_REQUEST,
  ADD_MORE_TINS_DATA_SUCCESS,
  ADD_MORE_TINS_DATA_FAILURE,
} from '@src/middleware/actions/actionTypes';

interface TinData {
  Tin: string;
  Selected?: boolean;
  selected?: boolean;
  [key: string]: unknown;
}

interface HiVolumeTinsState {
  data: TinData[];
  inValidTins: TinData[]; // Assuming this is for storing invalid TINs
  notFoundTins: TinData[]; // Assuming this is for storing TINs not found
  loading: boolean;
  error: string | null;
  listName: string;
  filterListSearch: string;
  reenterTins: boolean; // Assuming this is a flag to re-enter tins
  addMoreTinsSearch: string; // Assuming this is for adding more TINs search
  addMoreTinsData?: TinData[]; // Optional field for storing additional TINs data
}

const initialState: HiVolumeTinsState = {
  data: [],
  inValidTins: [], // Assuming this is for storing invalid TINs
  notFoundTins: [], // Assuming this is for storing TINs not found
  loading: false,
  error: null,
  listName: '',
  filterListSearch: '',
  reenterTins: false, // Assuming this is a flag to re-enter tins
  addMoreTinsSearch: '',
  addMoreTinsData: [], // Optional field for storing additional TINs data
};

const HiVolumeTinsReducer = (state = initialState, action: AnyAction): HiVolumeTinsState => {
  switch (action.type) {
    case FETCH_TINS_DETAILS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        data: action.payload || [],
      };
    case FETCH_TINS_DETAILS_SUCCESS: {
      // Add selected: true to each item in the data array
      const dataWithSelection = (action.payload.Data.ValidTins || []).map((item) => ({
        ...item,
        selected: item?.Selected ?? true,
      }));

      return {
        ...state,
        loading: false,
        data: dataWithSelection,
        inValidTins: action.payload.Data.InvalidTins || [],
        notFoundTins: action.payload.Data.NotFoundTins || [],
      };
    }
    case FETCH_TINS_DETAILS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_LIST_NAME:
      return {
        ...state,
        listName: action.payload,
      };
    case SET_FILTER_LIST_SEARCH: {
      return {
        ...state,
        filterListSearch: action.payload,
      };
    }
    case REENTER_TINS:
      return {
        ...state,
        reenterTins: true, // Set the flag to true when re-entering tins
      };
    case SAVE_CUSTOM_LIST_REQUEST:
      // Handle request to save custom list
      return {
        ...state,
        loading: true,
        error: null,
      };
    case SAVE_CUSTOM_LIST_SUCCESS:
      // Handle success response for saving custom list
      return {
        ...state,
        loading: false,
      };
    case SAVE_CUSTOM_LIST_FAILURE:
      // Handle error response for saving custom
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case RESET_TINS_DETAILS:
      // Resetting the tins details to initial state
      sessionStorage.removeItem('reenterTins'); // Clear the session storage flag
      return {
        ...state,
        addMoreTinsData: [],
        addMoreTinsSearch: '',
        filterListSearch: '',
        listName: '',
      };
    case SET_ADD_MORE_TINS_SEARCH:
      // Handle setting the search for adding more TINs
      return {
        ...state,
        addMoreTinsSearch: action.payload,
      };
    case ADD_MORE_TINS_DATA_REQUEST: // Custom action to add more TINs data
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_MORE_TINS_DATA_SUCCESS: // Custom action for successful addition of more TINs data
      return {
        ...state,
        loading: false,
        addMoreTinsData: action.payload?.Data || [], // Assuming payload contains the additional TINs data
      };
    case ADD_MORE_TINS_DATA_FAILURE: // Custom action for failure in adding more TINs data
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case ADD_SINGLE_TIN_TO_LIST_REQUEST:
      // Handle request to add a single TIN to the list
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ADD_SINGLE_TIN_TO_LIST_SUCCESS: {
      const payload = {
        ...action.payload,
        selected: true, // Assuming we want to mark the added TIN as selected
      };
      return {
        ...state,
        loading: false,
        data: [payload, ...state.data],
      };
    }
    case ADD_SINGLE_TIN_TO_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_TIN_SELECTION: {
      const updatedData = state.data.map((item) =>
        item.Tin === action.payload.tin ? { ...item, selected: action.payload.isSelected } : item
      );
      return {
        ...state,
        data: updatedData,
      };
    }
    default:
      return state;
  }
};

export default HiVolumeTinsReducer;
